// extracted by mini-css-extract-plugin
module.exports = {"title":"FaqAccordion_title__BOicF","body":"FaqAccordion_body__PbR9H","container":"FaqAccordion_container__nYfJh","expanded":"FaqAccordion_expanded__vHhQj"};